import { apiGet } from "@redriver/cinnamon";

const NAMESPACE = "COMPANIES/CUSTOMERS";

const ActionTypes = {
  getNewCustomerCrmUrl: `${NAMESPACE}/GET_NEW_CRM_URL`,
  getCrmClientDetails: `${NAMESPACE}/GET_CRM_CLIENT_DETAILS`,
  getCustomerCrmUrl: `${NAMESPACE}/GET_CRM_URL`,
};

export const getNewCustomerCrmUrl = ({ data }) => {
  return apiGet(
    ActionTypes.getNewCustomerCrmUrl,
    `clients/new-customer-crm-url`,
    data,
  );
};

export const getCustomerCrmUrl = ({ data }) => {
  return apiGet(
    ActionTypes.getCustomerCrmUrl,
    `clients/new-customer-crm-url`,
    data,
  );
};

export const getCrmClientDetails = (clientId) => {
  return apiGet(ActionTypes.getCrmClientDetails, `clients/${clientId}`);
};
